import {
  CheckboxAdditionalContent,
  CheckboxContainer,
  CheckboxDescription,
  CheckboxTitle,
  StyledCheckboxField,
} from './Styled';

type Props = {
  fieldName: string;
  dataTestId: string;
  title: string;
  description: string;
  children?: React.ReactNode;
};

export const CheckboxFormField = ({
  dataTestId,
  fieldName,
  title,
  description,
  children,
}: Props) => {
  return (
    <CheckboxContainer data-test={`form-field-${dataTestId}`}>
      <StyledCheckboxField name={fieldName} />
      <CheckboxTitle>{title}</CheckboxTitle>
      <CheckboxDescription>{description}</CheckboxDescription>
      {children && <CheckboxAdditionalContent>{children}</CheckboxAdditionalContent>}
    </CheckboxContainer>
  );
};
